import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Box, IconButton, Menu, MenuItem } from "@mui/material";

import { GridColDef } from "@mui/x-data-grid";

import TableComponent from "../../components/TableComponent";
import { PAYMENT_STATUS_LABELS } from "../../utils/enums";
import { PriceFormatter } from "../../utils/commoFunctions";
import { generateEncryptedKeyBody } from "../../utils/crypto";
import { CommonBody, PaymentResponseType } from "../../types/General";
import { errorToast } from "../../helpers";
import { useGetAllPaymentsMutation } from "../../service/payments";
import moment from "moment";

const DashPayments = () => {
  const navigate = useNavigate();

  const [selectedId, setSelectedId] = useState<number | null>(null);

  const [allPayments] = useGetAllPaymentsMutation();
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState<PaymentResponseType[]>([]);
  const [page, setPage] = useState<number>(1);
  const handlePageChange = (event: any, newPage: number) => {
    setPage(newPage + 1);
  };

  const [anchorEl1, setAnchorEl1] = React.useState<null | HTMLElement>(null);
  const open1 = Boolean(anchorEl1);
  const handleClick1 = (
    event: React.MouseEvent<HTMLButtonElement>,
    rowId: number
  ) => {
    setAnchorEl1(event.currentTarget);
    setSelectedId(rowId);
  };
  const handleClose1 = () => {
    setAnchorEl1(null);
    setSelectedId(null);
  };

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "paymentDate",
      headerName: "Payment Date",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>
              {row?.created_at
                ? moment(row?.created_at).format("DD MMM YYYY")
                : "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "applicationId",
      headerName: "Application Id",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.application?.apk_id || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 300,
      field: "applicantDetails",
      headerName: "User Details",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <figure
              onClick={() => navigate(`/users/individual/${row?.user?.id}`)}
            >
              <img
                src={
                  row?.user?.profile_picture?.media_url ||
                  "/static/images/user_placeholder.png"
                }
                alt=""
              />
            </figure>
            <p>
              <b>{row?.user?.name || "-"}</b> {row?.user?.country_code}{" "}
              {row?.user?.phone_no || ""} <br />
              {row?.user?.email || "-"}
            </p>
          </div>
        );
      },
    },

    {
      flex: 1,
      minWidth: 150,
      field: "paymentMode",
      headerName: "Payment Mode",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{row?.plan_mode?.title || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "paymentType",
      headerName: "Payment Type",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        const partNumber = row?.plan_part_no?.part_number;
        return (
          <div className="user_block">
            <p>
              {partNumber !== null && partNumber !== undefined
                ? PAYMENT_STATUS_LABELS[row?.plan_part_no?.part_number]
                : "-"}
            </p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "amountPaid",
      headerName: "Amount Paid",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{PriceFormatter(row?.payment_amt?.toString()) || "-"}</p>
          </div>
        );
      },
    },
    {
      flex: 1,
      minWidth: 150,
      field: "remainingAmount",
      headerName: "Remaining Amount",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="user_block">
            <p>{PriceFormatter(row?.remaining_amt?.toString()) || "-"}</p>
          </div>
        );
      },
    },

    {
      flex: 0.1,
      minWidth: 80,
      field: "action",
      headerName: "Action",
      editable: false,
      sortable: false,
      renderCell: ({ row }) => {
        return (
          <div className="table_actions">
            <Box>
              <IconButton
                aria-controls={open1 ? "basic-menu1" : undefined}
                aria-haspopup="true"
                aria-expanded={open1 ? "true" : undefined}
                onClick={(event) => handleClick1(event, row?.id)}
              >
                <img src="/static/images/more_icon.svg" alt="" />
              </IconButton>
              <Menu
                className="setting_menu"
                id="basic-menu1"
                anchorEl={anchorEl1}
                open={open1}
                onClose={handleClose1}
                MenuListProps={{
                  "aria-labelledby": "basic-button1",
                }}
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    boxShadow: "0px 4px 20px 0px rgba(0, 0, 0, 0.05)",
                    borderRadius: "8px",
                    mt: 1,
                  },
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
              >
                <MenuItem
                  onClick={() =>
                    navigate(`/manage-payments/payments/view/${selectedId}`)
                  }
                >
                  View
                </MenuItem>
              </Menu>
            </Box>
          </div>
        );
      },
    },
  ];

  const getPaymentList = async () => {
    setLoading(true);
    try {
      const body = {
        start: page,
        length: 5,
        search: "",
      };

      const encryptedBody = generateEncryptedKeyBody(body) as CommonBody;
      const response = await allPayments(encryptedBody).unwrap();
      setLoading(false);

      if (response?.status === 200) {
        setRows(response?.data?.response_object || []);
      } else {
        setRows([]);
      }
    } catch (error: any) {
      errorToast(error?.data?.message || "");
      setLoading(false);
    }
  };

  useEffect(() => {
    getPaymentList();
  }, []);

  return (
    <div className="cards table_card cards_100">
      <div className="cards_header">
        <div className="left_s">
          <h2>Payment History</h2>
          <p>Last 5 Payments</p>
        </div>
      </div>
      <Box className="custom_tabs" sx={{ width: "100%" }}>
        <div className="sorting_table">
          <TableComponent
            columns={columns}
            rows={rows}
            count={5}
            page={page}
            onPageChange={handlePageChange}
            loading={loading}
          />
        </div>
      </Box>
    </div>
  );
};

export default DashPayments;
